import React from 'react'
import cl from 'classnames'
import {
  IconAgreements,
  IconDashboard,
  IconPeople,
  IconProducts,
  IconProjects,
  IconStores,
  IconStatistics,
  IconActionHistory,
  IconViewers,
  IconUserManagement,
  IconArrowRight,
  IconArrowLeft,
  IconEmail
} from 'assets'
import { User } from 'utilities'
import { notAllowedUserRolesBySection } from 'config/not-allowed-user-roles-by-section'
import { NavMenuProps, SideMenuProps } from './SideMenu.types'
import {
  SectionContainer,
  Button,
  SideMenuSectionButton
} from '@touche-lts/panel-ui/dist'
import { inject } from 'mobx-react'
import { GENERAL_STORE, ROUTING_STORE } from 'store'
import { observer } from 'mobx-react-lite'
import styles from './SideMenu.module.scss'

const navMenu: NavMenuProps[] = [
  {
    icon: IconDashboard,
    label: 'Dashboard',
    navPath: '/dashboard',
    notAllowedUserRoleNames: notAllowedUserRolesBySection.dashboard
  },
  {
    icon: IconProjects,
    label: 'Projects',
    navPath: '/projects',
    notAllowedUserRoleNames: notAllowedUserRolesBySection.projects
  },
  {
    icon: IconPeople,
    label: 'People',
    navPath: '/persons',
    notAllowedUserRoleNames: notAllowedUserRolesBySection.people
  },
  {
    icon: IconStores,
    label: 'Stores',
    navPath: '/brands',
    notAllowedUserRoleNames: notAllowedUserRolesBySection.brands
  },
  {
    icon: IconProducts,
    label: 'Products',
    navPath: '/products',
    notAllowedUserRoleNames: notAllowedUserRolesBySection.products
  },
  {
    icon: IconAgreements,
    label: 'Agreements',
    navPath: '/agreements',
    notAllowedUserRoleNames: notAllowedUserRolesBySection.agreements
  },
  {
    icon: IconStatistics,
    label: 'Statistics',
    navPath: '/statistics',
    notAllowedUserRoleNames: notAllowedUserRolesBySection.statistics
  },
  {
    icon: IconActionHistory,
    label: 'My action history',
    navPath: '/action-history',
    notAllowedUserRoleNames: notAllowedUserRolesBySection.actionHistory
  },
  {
    icon: IconViewers,
    label: 'Viewers',
    navPath: '/viewers',
    notAllowedUserRoleNames: notAllowedUserRolesBySection.viewers
  },
  {
    icon: IconUserManagement,
    label: 'User management',
    navPath: '/user-management',
    notAllowedUserRoleNames: notAllowedUserRolesBySection.userManagement
  },
  {
    icon: IconEmail,
    label: 'Allowed-Email List',
    navPath: '/sso-allowed-emails',
    notAllowedUserRoleNames: notAllowedUserRolesBySection.allowedEmail
  }
]

const SideMenuComponent = (props: SideMenuProps) => {
  const {
    [ROUTING_STORE]: {
      push,
      location: { pathname }
    },
    [GENERAL_STORE]: { isSideMenuExpanded, switchSideMenuExpandedState }
  } = props

  const isAuthenticated = User.isAuthenticated()
  const isExpanded = isAuthenticated && isSideMenuExpanded

  return (
    <div
      className={cl(
        styles.shell,
        isAuthenticated && isSideMenuExpanded && styles.shellExpanded
      )}
    >
      <div className={styles.inner}>
        <SectionContainer
          className={styles.container}
          style={{
            padding: '40px 0 12px 10px',
            height: 'auto'
          }}
        >
          <div className={styles.navList}>
            {navMenu.map(navProps => (
              <SideMenuSectionButton
                key={navProps.navPath}
                icon={navProps.icon}
                label={navProps.label}
                onClick={() => push(navProps.navPath)}
                isSelected={pathname.includes(navProps.navPath)}
                notAllowedForLoggedUser={!User.userRoleNames.some(
                  roleName =>
                    !(navProps.notAllowedUserRoleNames || []).includes(roleName)
                )}
                disabled={!isAuthenticated}
              />
            ))}
          </div>
          {isAuthenticated && (
            <Button
              preset='icon'
              className={styles.arrow}
              onClick={() => switchSideMenuExpandedState()}
            >
              {isExpanded ? (
                <IconArrowLeft />
              ) : (
                <IconArrowRight />
              )}
            </Button>
          )}
        </SectionContainer>
      </div>
    </div>
  )
}

const SideMenu = inject(GENERAL_STORE, ROUTING_STORE)(observer(SideMenuComponent))
export { SideMenu }
